import firebase from 'firebase'

var config

if (process.env.NODE_ENV === 'production') {
  config = {
    apiKey: 'AIzaSyAOPbfRUm99Z4PKQ9nfm7S1DLigGeybyIo',
    authDomain: 'sumo-fff13.firebaseapp.com',
    databaseURL: 'https://sumo-fff13.firebaseio.com',
    projectId: 'sumo-fff13',
    storageBucket: 'sumo-fff13.appspot.com',
    messagingSenderId: '396377713646',
    appId: '1:396377713646:web:5baa752463e915fd4d7cff',
    measurementId: 'G-B3EL5VYCVD'
  }
} else {
  config = {
    apiKey: 'AIzaSyDpMnpGo6dpaht1vaVZTI4faHlT-FzDG8I',
    authDomain: 'the-hoods-dev.firebaseapp.com',
    databaseURL: 'https://the-hoods-dev.firebaseio.com',
    projectId: 'the-hoods-dev',
    storageBucket: 'the-hoods-dev.appspot.com',
    messagingSenderId: '922872657895',
    appId: '1:922872657895:web:c25975f2d86264e389ef42',
    measurementId: 'G-BC77LMSTE9'
  }
}

firebase.initializeApp(config)
firebase.analytics()
export const API_BASE = process.env.NODE_ENV === 'production' ? 'https://us-central1-sumo-fff13.cloudfunctions.net/' : 'https://us-central1-the-hoods-dev.cloudfunctions.net/'
export const firebaseDB = firebase.database
export const firebaseAuth = firebase.auth
export const firebaseStorageRef = firebase.storage().ref()
